export default "__VITE_ASSET__BTRL3COX__"